module.exports = __webpack_public_path__ + "img/31.0344a185.jpg";